/**
 * 车辆诊断车身类型变更数据(昆仑山设备)
 */
import React, { useState, useEffect, Fragment } from 'react';
import CommonTable from '@/components/commonTable';
import ExportButton from '@/components/exportButton';
import {
  carDiagnosisVehicleTypeRequest,
  carDiagnosisVehicleTypeRequestPath
} from '@/service/carDiagnosis';
import { useTable } from '@/utils/useTable';
import { formatTime } from '@/utils/formatTime';

interface KlsVehicleTypeTableProps {
  diagnosisSearchParams: any;
  getExportParams: () => any;
}

const carTypeDes: {[key: string]: string} = {
  1: '金旅大客车',
  2: '比亚迪e6',
  3: '解放箱货',
  4: '长城vv6'
}

const KlsVehicleTypeTable = (props: KlsVehicleTypeTableProps) => {
  const { diagnosisSearchParams, getExportParams } = props;
  const [searchParams, setSearchParams] = useState(diagnosisSearchParams);
  // 监听搜索参数的变化重新获取数据
  useEffect(() => {
    setSearchParams(diagnosisSearchParams);
  }, [diagnosisSearchParams]);

  const { page, limit, loading, data, totalCount, onPageChange } = useTable({
    requestFunc: carDiagnosisVehicleTypeRequest,
    initRequest: Boolean(diagnosisSearchParams),
    initPageSize: 40,
    searchParams
  });

  const columns = [
    {
      key: 'reportTime',
      title: '上报时间',
      dataIndex: 'reportTime',
      width: 170,
      render: (value: any) => formatTime(value),
      fixed: 'left' as const
    },
    {
      key: 'sn',
      title: '设备SN',
      dataIndex: 'sn',
      width: 170
    },
    {
      key: 'carType',
      title: '车身类型',
      dataIndex: 'carType',
      width: 100,
      render: (_: any, record: any) => (
        <>
        {carTypeDes[record.carType]}
        </>
      )
    }
  ];

  return (
    <Fragment>
      <div style={{ margin: '12px 0', textAlign: 'right' }}>
        <ExportButton
          type="primary"
          disabled={!diagnosisSearchParams}
          url={carDiagnosisVehicleTypeRequestPath}
          fileName={`${diagnosisSearchParams?.plateNumber}车身类型变更信息`}
          getParamsFunc={getExportParams}
          requestMethod="GET"
          permissionKey="/car-admin/car-diagnosis/car-type-export"
        />
      </div>
      <CommonTable
        rowKey="id"
        columns={columns}
        dataSource={data}
        pagination={{
          total: totalCount,
          current: page,
          pageSize: limit,
          onChange: onPageChange
        }}
        bordered
        loading={loading}
        scroll={{ x: '100%', y: 400 }}
      />
    </Fragment>
  );
};

export default KlsVehicleTypeTable;
